export const CAREER_SCROLLERS_ID = 'careerScrollers';
// Spec 04 section 2 names the four scrollspy anchors, and they are the page's
// deep links: /occupation/:onetCode#schools has to land on this section. The
// tutorial dialog scrolls to the same constant, so both move together.
export const SCHOOLS_EL_ID = 'schools';
export const BUILD_TARGET = 'buildTarget';
export const CAREER_PLANNING_TABS = 'career-planning-tabs';
